export default function Hero({ studio }) {
  const t = useI18n()
  const renderBanner = () => {
    if (!studio.bannerUrl) return <div className='w-full h-full bg-gray-100'></div>
    return <C.Image
      className='w-full h-full'
      src={ studio.bannerUrl }
    />
  }

  const authTitle = studio.authorized ? { title: t('page:studioId.authStudio', { name: studio.name }) } : null

  const authClick = () => {
    if (!authTitle) return
    alert(authTitle.title)
  }

  const renderBadge = () => {
    if (!authTitle) return
    return <span className='cursor-pointer' { ...authTitle } onClick={ authClick }><Icon.ShieldCheck /></span>
  }

  return (
    <div
      className='w-full h-[10rem] flex relative mb-9'
    >
      <div className='absolute inset-0'>
        { renderBanner() }
      </div>
      <C.Blur dark/>
      <div className='container relative flex-1 flex space-x-4 pt-[6.4rem] md:pt-[5.4rem]'>
        <C.Avatar
          src={ studio.largeLogoUrl }
          className='ml-2 w-24 h-24 cursor-pointer shrink-0 shadow md:w-28 md:h-28'
          onClick={ () => h.$singlePhoto(studio.largeLogoUrl) }
        />
        <div className='pt-[1.8rem] md:pt-[2.6rem]'>
          <div className='text-white text-xl font-bold flex space-x-2 items-center'>
            <div className='line-clamp-1' { ...authTitle } onClick={ authClick }>{ studio.name }</div>
            { renderBadge() }
          </div>
          <div className='flex items-center cursor-pointer space-x-1 pt-3 md:pt-4' onClick={ () => h.reviewOpen({ type: 'studio', id: studio.id }) }>
            <C.Stars
              score={ studio.rating }
              className='w-4 h-4'
            />
            <div className='text-sm font-medium'>
              { t('common:ratingCount', { count: studio.totalRatingCount.format() }) }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
